import React from 'react';

function Colombia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124159)">
        <mask
          id="mask0_800_124159"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124159)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#2E42A5"
          />
          <mask
            id="mask1_800_124159"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124159)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V12H36V0H0Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 18V24H36V18H0Z"
              fill="#E31D1C"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124159">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Colombia;
